import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

function statusDotClass(status) {
  if (status === "completed") return "completed";
  if (status === "error") return "error";
  return "working";
}

export default function HistoryPage({ onOpenRun }) {
  const [runs, setRuns] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);
  async function load() {
    try { const { data } = await api.get("/runs"); setRuns(data); }
    catch (e) { setErr("Could not load runs."); }
  }
  async function del(id, e) {
    e.stopPropagation();
    if (!window.confirm("Delete this run?")) return;
    await api.delete(`/runs/${id}`).catch(() => {});
    load();
  }

  return (
    <div className="grain blueprint-grid min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <div className="mb-8">
          <div className="label-xs">Archive</div>
          <h1 className="font-serif-display text-5xl tracking-tighter">Past runs.</h1>
        </div>

        {err && <div className="font-mono text-sm text-[#FF5B5B]">{err}</div>}

        <div className="border-t border-l hairline">
          {runs === null && (
            <div className="p-8 font-mono text-sm">Loading…</div>
          )}
          {runs && runs.length === 0 && (
            <div className="p-8 font-mono text-sm text-[#A8B3C7]" data-testid="history-empty">
              No runs yet. Dispatch your first goal from the Console.
            </div>
          )}
          {runs && runs.map((r) => (
            <button
              key={r.id}
              onClick={() => onOpenRun(r.id)}
              className="w-full text-left grid grid-cols-12 border-r border-b hairline hover:bg-[#FFFFFF08] transition-colors"
              data-testid={`run-row-${r.id}`}
            >
              <div className="col-span-12 md:col-span-7 p-5">
                <div className="label-xs mb-1">{new Date(r.created_at).toLocaleString()}</div>
                <div className="font-serif-display text-2xl italic leading-tight">"{r.goal}"</div>
              </div>
              <div className="col-span-6 md:col-span-2 p-5 border-l hairline flex items-center font-mono text-sm capitalize">
                <span className={"dot mr-2 " + (r.status === "completed" ? "completed" : r.status === "error" ? "error" : "working")} />
                {r.status}
              </div>
              <div className="col-span-6 md:col-span-3 p-5 border-l hairline flex items-center justify-between">
                <span className="font-mono text-xs uppercase tracking-[0.18em] text-[#A8B3C7]">Open →</span>
                <span
                  role="button"
                  tabIndex={0}
                  onClick={(e) => del(r.id, e)}
                  onKeyDown={(e) => { if (e.key === "Enter") del(r.id, e); }}
                  className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF5B5B] hover:underline"
                  data-testid={`delete-run-${r.id}`}
                >
                  Delete
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
